import { render, staticRenderFns } from "./SettingsInvoiceDesign.vue?vue&type=template&id=826d6c74"
import script from "./SettingsInvoiceDesign.vue?vue&type=script&lang=js"
export * from "./SettingsInvoiceDesign.vue?vue&type=script&lang=js"
import style0 from "./SettingsInvoiceDesign.vue?vue&type=style&index=0&id=826d6c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports